export enum BundlesFareClass {
  /**
   * Previously, STANDARD
   */
  LIGHT = 'Y',
  /**
   * Previously, STANDARD_PLUS
   */
  SMART_PLUS = 'H',
  /**
   * Previously, ESSENTIALS
   */
  EXTRA = 'K',
  FLEXI = 'M',
  UNKNOWN = 'U'
}

export enum BundleName {
  LIGHT = 'Light',
  SMART = 'Smart',
  SMART_PLUS = 'Smart+',
  EXTRA = 'Extra',
  ALL_IN = 'All-in'
}

export const bundleDiscountAdjustmentCode = 'BundleAdjustment';
export const LOYALTY_DISCOUNT_ADJUSTMENT_CODE = 'LoyaltyAdjustment';

export enum BundleCode {
  LIGHT = 'F0D9OIQXCL',
  SMART = 'DB67MYPQSK',
  SMART_10 = 'OL74SNC55T',
  SMART_20 = 'Q6P08E0B1P',
  SMART_PLUS = 'H6V124RHY3',
  SMART_PLUS_10 = '8L72KACEQ8',
  SMART_PLUS_20 = 'P2V8TZNX50',
  EXTRA = '6YD791G89N',
  EXTRA_10 = 'NVNE20XYPD',
  EXTRA_20 = 'XF1LZOKKCE',
  ALL_IN = 'I8R386GGJL',
  ALL_IN_10 = 'CAJ942LX2U',
  ALL_IN_20 = 'VJJEJ0JD8T'
}

export enum BundleItemType {
  DYNAMIC = 'Dynamic',
  LOYALTY = 'Loyalty'
}

export enum BenefitCodes {
  SMALL_CABIN_BAG = 'B0001',
  CONDITIONAL_LARGE_CABIN_BAG = 'B0002',
  LARGE_CABIN_BAG = 'B0003',
  SPEEDY_BOARDING = 'B0006',
  DROP_BAG = 'B0007'
}

export interface BundleCodeFareClass {
  bundleCodes?: string[];
  fareClass?: string;
}

export type BundleAlias = 'light' | 'smart+' | 'extra' | 'smart' | 'all-in';

export const BUNDLE_CODE_MAP: Record<BundleAlias, BundleCodeFareClass> = {
  light: { fareClass: BundlesFareClass.LIGHT, bundleCodes: [BundleCode.LIGHT] },
  'smart+': {
    fareClass: BundlesFareClass.SMART_PLUS,
    bundleCodes: [BundleCode.SMART_PLUS, BundleCode.SMART_PLUS_10, BundleCode.SMART_PLUS_20]
  },
  extra: { fareClass: BundlesFareClass.EXTRA, bundleCodes: [BundleCode.EXTRA, BundleCode.EXTRA_10, BundleCode.EXTRA_20] },
  smart: { bundleCodes: [BundleCode.SMART, BundleCode.SMART_10, BundleCode.SMART_20] },
  'all-in': { bundleCodes: [BundleCode.ALL_IN, BundleCode.ALL_IN_10, BundleCode.ALL_IN_20] }
};

export const BundleNameMap: Record<BundleCode, BundleName> = {
  [BundleCode.LIGHT]: BundleName.LIGHT,
  [BundleCode.SMART]: BundleName.SMART,
  [BundleCode.SMART_10]: BundleName.SMART,
  [BundleCode.SMART_20]: BundleName.SMART,
  [BundleCode.SMART_PLUS]: BundleName.SMART_PLUS,
  [BundleCode.SMART_PLUS_10]: BundleName.SMART_PLUS,
  [BundleCode.SMART_PLUS_20]: BundleName.SMART_PLUS,
  [BundleCode.EXTRA]: BundleName.EXTRA,
  [BundleCode.EXTRA_10]: BundleName.EXTRA,
  [BundleCode.EXTRA_20]: BundleName.EXTRA,
  [BundleCode.ALL_IN]: BundleName.ALL_IN,
  [BundleCode.ALL_IN_10]: BundleName.ALL_IN,
  [BundleCode.ALL_IN_20]: BundleName.ALL_IN
};
